import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  root: {},
  icon: {
    fontSize: '1rem',
    opacity: 0.5,
    strokeWidth: 2,
    fill: theme.palette.common.black,
    stroke: theme.palette.common.black,
  },
});

const CloseButton = ({
  className,
  classes,
  onClose,
}) => {
  return (
    <IconButton
      aria-label="close"
      className={classNames(classes.root, className)}
      classes={{
        icon: classes.icon,
      }}
      color="darkGray"
      icon={CloseIcon}
      onClick={onClose}
      title="Close"
      test={'dialog-close-button'}
    />
  );
};

CloseButton.defaultProps = {
  className: '',
};

CloseButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(CloseButton);
